import { render, staticRenderFns } from "./MiniArrowIcon.vue?vue&type=template&id=b0f39fdc&"
import script from "./MiniArrowIcon.vue?vue&type=script&lang=ts&"
export * from "./MiniArrowIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports